<template>


    <div>
        <va-card class="flex xs12 sm12 lg12" >
            <p class="display-3 text-center">   {{$t('arealuno.Mensalidades')}}</p>
            <va-button   small color="warning" @click="chamar_termos()" class="ma-0 text-lefth">
                  
                  {{$t('arealuno.termos_condicoes')}}
                </va-button>
        
         <div class="row flex">
      
      <div class="md6 offset--md3">
      
          <va-data-table
          :fields="fields"
          :data="FaturasAluno"
          hoverable
          no-pagination
          > 
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>
              <template  slot="actions" slot-scope="props">
               
                <va-button v-if="props.rowData.status_venda == 0 "  small color="blurple" @click="adicionaFaturaVenda(props.rowData)" class="ma-0">
                 {{$t('arealuno.Pagar_fatura')}}
                </va-button>
                 <va-button v-if="props.rowData.status_venda == 1 "  small color="success" class="ma-0">
                 {{$t('arealuno.Pago')}}
                </va-button>
                <va-button v-if="props.rowData.status_venda == 3 "  small color="warning" class="ma-0">
                 {{$t('arealuno.Analise')}}
                </va-button>
            
              </template>
              
        </va-data-table>

      </div>

  

    </div>

</va-card>

        <!-- <va-card>
           <va-button color="info" @click="Pagar_fatura()">
            Enviar
          </va-button>
          <va-button color="primary" @click="Confirmar_pagamento()">
            confirmar Pagamento
          </va-button>
          <va-button color="danger" @click="Rollback()">
            Cancelar Venda
          </va-button>

            <div class="">
            <h1 style="text-align: center">Pago faturas</h1>
            <div style="height: 300px; width: 500px; margin: auto" id="iframe-container"></div>

            </div>
            
            
        </va-card> -->



         <!-- Inicio Modal -->
       <div class="modal" v-show="showModal" >
        <div class="modal-wrapper">
          <div class="modal-container">
            <content select="modal-header">
              <div class="modal-header">
                <h3 class="text-center">
                   {{$t('arealuno.Pagamento_online')}}
                </h3>
                <div class="row">

                    <div class=" flex xs12 sm12 lg4 text-lefth">
                        <!-- <va-button v-if="!quadro_pagamento"   color="blurple" @click="Gerar_pagamento()" >  {{$t('arealuno.Finalizar_pagamento')}} </va-button> -->
                    
                    </div>
                    <div class=" flex xs12 sm12 lg4 text-center">
                      <p v-if="!quadro_pagamento" class="display-1 text-center">  G$ {{get_faturas_carriho.soma_total}} </p>
                    </div>

                    <div class="flex xs12 sm12 lg4 text-right">
                        <va-button  @click="showModal = false"  color="info" >{{$t('arealuno.Fechar')}}</va-button>
                
                    </div>
                    
              
                </div>
              
              </div>
            </content>
            <hr>
           

        <div class="row scroll">


                 <!-- Inicio Tabela -->
            <div v-if="tabela_preco" class="flex xs12 sm12 lg12 ">
                <div v-for="(fatura, index) in get_faturas_carriho.faturas_carrinho" :key="index">

                <div class="va-item align--center no-wrap va-item--clickable" @click="removerFaturaVenda(fatura)">
                <div class="va-item-section va-item-section--main">
                        <div class="va-item-label ellipsis">
                            {{ fatura.nome_curso }}
                        </div>
                    </div>
                    <div class="va-item-section va-item-section--main">
                        <div class="va-item-label ellipsis">
                            {{ fatura.data_vencimento }}
                        </div>
                    </div>
                    <div class="va-item-section va-item-section--main">
                        <div class="va-item-label ellipsis">
                           G$ {{ fatura.valor }}
                        </div>
                    </div>
                    

                   <div color="red" class="va-item-label ellipsis va-item-label--caption">
                           {{$t('arealuno.Excluir')}}
                    </div>
                </div>
                    <div>
                        <div class="va-list-separator va-list-separator--offset"></div>
                    </div>
                </div>

            </div>
            <!-- Fim Tabela -->

                <!-- Inicio botao pagamento -->
                <div v-if="tabela_preco"  class="row ">

                      <div class="flex xs12 sm12 lg12 text-center ">
                         
                            <va-button v-if="!quadro_pagamento"   color="blurple" @click="Gerar_pagamento()" >  {{$t('arealuno.Pagamento_online')}} </va-button>
                            <va-button  v-if="!quadro_pagamento" @click="Pagamento_deposito()" color="info" >{{$t('arealuno.Enviar_comprovante')}}</va-button>
                      </div>
                  
                </div>
                <!-- Fim botao pagamento -->


                  <!-- Inicio tela pagamento bancard -->
                <div v-if="quadro_pagamento" class="row">

                    <div class="flex xs12 sm12 lg4">
                         <p class="display-2 text-center">  Total </p>
                         <p class="display-1 text-center">  G$ {{get_faturas_carriho.soma_total}} </p>
                    </div>

                     <div class="flex xs12 sm12 lg8">
                        <div style="height: 300px; width: 500px; margin: auto" id="iframe-container"></div>
                    </div>

                </div>
                <!-- Fim Tela pagamento -->

                <!-- Inicio tela pagamento comprovante -->

                <div v-if="pagamento_deposito" class="row">

                    <div class="flex xs12 sm12 lg4">
                         <p class="display-2 text-center">  Total </p>
                         <p class="display-1 text-center">  G$ {{get_faturas_carriho.soma_total}} </p>
                    </div>

                     <div class="flex xs12 sm12 lg8">
                          <!-- Inicio Formulario -->
                            <div class="flex">
                                <div class="row">
                                      <div class="flex  md12 sm12 xs12 lg6">
                                        <va-input
                                        :label="'Fecha deposito'"
                                          v-model="arquivo.data_pagamento"
                                          type="date"
                                          placeholder="Fecha deposito"
                                        />
                                      </div>

                                      <!-- <div class="flex md12 sm12 xs12 lg6">
                                        <va-select
                                          :label="'Tipo pagamento'"
                                          v-model="arquivo.tipo_pagamento"
                                           type="text"
                                         
                                          placeholder="Tipo"
                                        />
                                      </div> -->
                                </div> 
                              </div>

                              
                             
                              <div class="helper">

                              </div>
                              <div class="drop display-inline align-center" @dragover.prevent @drop="onDrop">
                                  <div class="helper"></div>
                                          <label v-if="!image" class="btn display-inline">
                                            SELECIONE UMA IMAGEM
                                            <input type="file" id="file" ref="file" name="image" @change="onChange">
                                          </label>
                                          <div class="hidden display-inline align-center" v-else v-bind:class="{ 'image': true }">
                                          <img :src="image" alt="" class="img" />
                                          <br>
                                          <br>
                                          <va-button color="danger" @click="removeFile">BORRAR</va-button>
                                          <va-button   v-on:click="submitFile()"  color="dark"> {{$t('arealuno.Subir')}}</va-button>
                                        </div>
                                  </div>
                                  
                            </div>
                             <div class="flex md12 sm12 xs12 lg12 text-center">
                                  
                              </div>
                              <br>
                                  <br>
                                  <br>
                                  <br>
                                  <br>
                        <!-- Fim Formulario -->
                    </div>


                </div>

                <!-- Fim tela pagamento -->
            
            
         
         </div>
      
          </div>
        </div>
     
      <!-- Fim Modal -->
    </div>




</template>


<script>

import axios from 'axios';
export default {
    name:'financeiro',

    data () {
        return {
            showModal: false,
            tabela_preco:true,
            quadro_pagamento:false,
            pagamento_deposito:false,
            envio:'',
            processo_id: this.$store.state.financeiro.processo_id,
            dados_para_processo_id:{
                    shop_process_id: '',
                    amount: "",
                    currency: "PYG",
                    additional_data: "",
                    description: "",
                    return_url: "http://posgrado.plataforma.ucpvirtual.com.br/#/alunos/confirm",
                    cancel_url: "http://posgrado.plataforma.ucpvirtual.com.br/#/alunos/faill"
            },
            tempo: '',
            faturas_inseridas:[],

            tipos_pagamento:[
              {nome:'Deposito banca',id:'1'},
              {nome:'Wester Union',id:'2'}
            ],
            soma_total: parseFloat(0),

            arquivo:{
              nome:'',
              file:'',
              tipo_arquivo_id:6,
              data_pagamento:'',
              tipo_pagamento:''
           },
            image: '',
            file:'',
        }

    },

    created(){
        this.all()
        this.teste()
    },
    computed:{

        get_faturas_carriho(){   
        
        return this.$store.state.financeiro.faturas_inseridas
      
        },

        tratar_ponto(){
            
          return  parseFloat(this.soma_total.replace(',', '.'))

        },

        FaturasAluno (){ return   this.$store.state.financeiro.faturas_aluno },

        fields () {
            return [{
            name: '__slot:marker',
            width: '30px',
            dataClass: 'text-center',
            }, {
            name: 'nome_curso',
            title: 'Curso',
            },{
            name: 'nome_produto',
            title: this.$t('arealuno.Detalhes'),
            },{
            name: 'data_vencimento',
            title: this.$t('arealuno.Data_vencimento'),
            },{
            name: 'data_pagamento',
            title: this.$t('arealuno.Data_pagamento'),
            },{
            name: 'tipo_pagamento',
            title: this.$t('arealuno.Tipo_pagamento'),
            },{
            name: 'valor',
            title: this.$t('arealuno.Valor'),
            },{
            name: 'acion',
            dataClass: 'text-right',
            title: '',
            
            }, {
            name: '__slot:actions',
            dataClass: 'text-center',
            }]
        },

        
    },
  
    methods:{

      async Pagamento_deposito(){

          this.dados_para_processo_id.shop_process_id = this.$store.state.financeiro.faturas_inseridas.pagamento_id
          this.dados_para_processo_id.amount = this.$store.state.financeiro.faturas_inseridas.soma_total_sem
          this.dados_para_processo_id.description = 'Pago un valor de matricula'
          

          this.tabela_preco = false
          this.pagamento_deposito = true
              

        //  await  this.$store.dispatch('GerarVendaId',this.dados_para_processo_id)
        //       console.log(this.$store.state.financeiro.processo_id)

        
      },
 
      async adicionaFaturaVenda(value) {
           this.quadro_pagamento =false
           this.pagamento_deposito=false,
            this.tabela_preco = true
             await this.$store.dispatch('Add_fatura_carrinho',value)
             this.showModal = true
           
        },
        async removerFaturaVenda(value) {
            this.quadro_pagamento =false
            this.tabela_preco = true
            
             await this.$store.dispatch('Remover_fatura_carrinho',value)
          
        },

      remover_produto(index, value) {
        this.soma_total -= parseInt(value.valor);
        this.faturas_inseridas.splice(index, 1);
      },
      teste(){
        // setTimeout(this.showModal =false, 2000)
        // setInterval(this.contador_tempo, 1000);
      },
      async all(){
             await  this.$store.dispatch('Faturas_aluno',this.$store.state.alunos.get_aluno.id)
        },

      async Gerar_pagamento(){

    
           this.dados_para_processo_id.shop_process_id = this.$store.state.financeiro.faturas_inseridas.pagamento_id
           this.dados_para_processo_id.amount = this.$store.state.financeiro.faturas_inseridas.soma_total_sem + '.00'
           this.dados_para_processo_id.description = 'Pago un valor de matricula'
          
                this.tabela_preco = false
                this.quadro_pagamento =true

        await  this.$store.dispatch('PegarProcessoId',this.dados_para_processo_id)
               console.log(this.$store.state.financeiro.processo_id)
                this.frame_pagamento()
                    
      },
      frame_pagamento(){

            let styles = {
                    "form-background-color": "#001b60",
                    "button-background-color": "#4faed1",
                    "button-text-color": "#fcfcfc",
                    "button-border-color": "#dddddd",
                    "input-background-color": "#fcfcfc",
                    "input-text-color": "#111111",
                    "input-placeholder-color": "#111111"
                    };
            
                Bancard.Checkout.createForm ('iframe-container', this.$store.state.financeiro.processo_id ,styles); 
      },

      async Confirmar_pagamento(){
          
              await  this.$store.dispatch('Confirmar_pagamento',this.dados_para_processo_id.shop_process_id)
      
      },
      async Rollback(){
          
              await  this.$store.dispatch('Rollback',this.dados_para_processo_id.shop_process_id)
      
      },
      chamar_termos(){
          this.$router.push({ name: 'alunos/termos' })
      },

      async submitFile (){
         let formData = new FormData();
         formData.append('file', this.file);
         formData.append('nome', 'Comprovante pagamento');
         formData.append('tipo', 'comprovante_pagamento');
         formData.append('tipo_arquivo_id', 6);
         formData.append('aluno_id', this.$store.state.alunos.getAluno.id);
         //formData.append('tipo_pagamento', this.arquivo.tipo_pagamento.nome);
         formData.append('data_pagamento', this.arquivo.data_pagamento);
         formData.append('shop_process_id', this.$store.state.financeiro.faturas_inseridas.pagamento_id);
         formData.append('amount', this.$store.state.financeiro.faturas_inseridas.soma_total_sem);
       

  
        await this.$store.dispatch('addArquivoComprovante',formData)
               
          this.all()
          this.showModalArquivo = false
           this.showModal= false
           this.file = ''
           this.image = ''
               
            this.arquivo = {
                      nome:'',
                      file:'',
                      
                      tipo_arquivo_id:6,
                    }
            
     
      },

      handleFileUpload(){
        this.file = this.$refs.file.files[0];
      },


      // metodos para upload de imagem

       onDrop: function(e) {
        e.stopPropagation();
        e.preventDefault();
        var files = e.dataTransfer.files;
        this.createFile(files[0]);
      },
      onChange(e) {
        var files = e.target.files;
        this.createFile(files[0]);
        this.file = this.$refs.file.files[0];
      },
      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('Select an image');
          return;
        }
        var img = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = function(e) {
          vm.image = e.target.result;
        }
        reader.readAsDataURL(file);
      },
      removeFile() {
        this.image = '';
      }

      // termino metodos par upload de imagem

    }
    
}
</script>

<style lang="scss" scoped>

#child { 
  position: absolute; 
  right: 40px; 
  top: 100px; 
  width: 200px; 
  height: 200px; 
 
  text-align: center; 
}

.scroll{
  overflow-y: scroll;
  max-height: 480px;

}

//rodape
.rodape {
    position:absolute;
    bottom:0;
    width:100%;
}

// texto embaixo
.embaixo{
   position: absolute;
   top: 65%;
   margin: auto;
   display:inline;
   text-align: right;
}



// daqui para baixo é do modal
 .modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
  
  
  &-wrapper {
   // display: table-cell;
    vertical-align: middle;
  }
  
  &-container {
    
    background: #fff;
    width: 70%;
   // height: 90%;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
  //  transition: all .3s ease;
    margin:  auto;
    margin-top: 100px;
    padding: 20px 30px;
  }
  
  &-footer {
    margin-top: 15px;
  }
  
  &-enter, &-leave {
    opacity: 0;
  }
  
  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}



// quadro do upload da imagem
// * {
//   font-family: 'Arial';
//   font-size: 12px;
// }

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
}

// html, body {
// 	height: 100%;
//   text-align: center;
// }

.btn {
  background-color: #d3394c;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  padding: 15px 35px;
  position: relative;
}

.btn:hover {
  background-color: #722040;
}

input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.align-center {
  text-align: center;
}

.helper {
  height: 100%;
  display: inline-block;
  vertical-align: middle;
  width: 0;
}

.hidden {
  display: none !important;
}

.hidden.image {
  display: inline-block !important;
}

.display-inline {
  display: inline-block;
  vertical-align: middle;
}

.img {
  border: 1px solid #f6f6f6;
  display: inline-block;
  height: auto;
  max-height: 80%;
  max-width: 80%;
  width: auto;
}

.drop {
  background-color: #f2f2f2;
  border: 4px dashed #ccc;
  background-color: #f6f6f6;
  border-radius: 2px;
  height: 100%;
  max-height: 400px;
  max-width: 600px;
  width: 100%;
}
// termino do quadro upload da imagem

</style>